import { useEffect } from "react";
import Icon from "components/Icon";
import { useSidebarToggle } from "context/ToggleSideBarContext";

export default function ToggleSidebarButton() {
  const { toggleSidebar } = useSidebarToggle();

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.ctrlKey && e.key.toLowerCase() === "b") {
        e.preventDefault();
        toggleSidebar?.();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [toggleSidebar]);

  return (
    <Icon name="menu" onClick={toggleSidebar} />
  );
}
